export default "__VITE_ASSET__B$iE8Zle__"